import { FrozenTheme } from "../.internal/themes/FrozenTheme";
export default FrozenTheme;